<div *adaptLoading="isLoading">
    <dx-data-grid noDataText="No Career Valuations"
                  [dataSource]="data"
                  [allowColumnResizing]="true"
                  [allowColumnReordering]="true"
                  [wordWrapEnabled]="true"
                  [rowAlternationEnabled]="true"
                  [hoverStateEnabled]="true"
                  [showRowLines]="true"
                  [showBorders]="true"
                  [stateStoring]="dxGridHelper.stateStoringOptions"
                  (onInitialized)="onGridInitialized($event)"
                  (onExporting)="onGridExporting($event)">
        <dxo-data-grid-paging [pageSize]="25"></dxo-data-grid-paging>
        <dxo-data-grid-pager [showPageSizeSelector]="true"
                             [allowedPageSizes]="[15, 25, 50, 100, 250]"></dxo-data-grid-pager>
        <dxo-data-grid-column-fixing [enabled]="true"></dxo-data-grid-column-fixing>
        <dxo-data-grid-scrolling [useNative]="false"></dxo-data-grid-scrolling>
        <dxo-data-grid-header-filter [visible]="true"></dxo-data-grid-header-filter>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-group-panel [visible]="true"></dxo-data-grid-group-panel>
        <dxo-data-grid-grouping [autoExpandAll]="true"></dxo-data-grid-grouping>
        <dxo-data-grid-column-chooser [enabled]="true"> </dxo-data-grid-column-chooser>
        <dxo-data-grid-export [enabled]="true"
                              fileName="Career Valuation Analysis">/</dxo-data-grid-export>
        <dxo-data-grid-load-panel [enabled]="true"></dxo-data-grid-load-panel>
        <dxi-data-grid-column caption="Person"
                              dataField="person.fullName"
                              dataType="string"
                              cellTemplate="personCellTemplate"
                              [width]="200"></dxi-data-grid-column>

        <dxi-data-grid-column [caption]="culturalLeadershipConfiguration.primaryName"
                              dataField="dummy_culturalleader"
                              dataType="string"
                              [calculateCellValue]="calculateCulturalLeadersCellValue"
                              [calculateGroupValue]="calculateCulturalLeadersGroupValue"
                              [customizeText]="culturalLeadersCustomizeText"
                              [groupIndex]="0"
                              [allowSorting]="true"
                              [allowGrouping]="true"
                              [allowFiltering]="true"
                              cellTemplate="culturalLeaderCellTemplate"
                              groupCellTemplate="culturalLeaderGroupCellTemplate"
                              [width]="200">
            <dxo-data-grid-header-filter [dataSource]="culturalLeadersHeaderItems"></dxo-data-grid-header-filter>
        </dxi-data-grid-column>

        <dxi-data-grid-column caption="Career Valuation"
                              dataField="careerValuation.extensions.actualTotal"
                              dataType="number"
                              [customizeText]="this.careerValuationUiService.customiseValueCellText"
                              [cellTemplate]="this.careerValuationUiService.getValueCellTemplate"
                              [headerFilter]="headerFilter"
                              [width]="150"></dxi-data-grid-column>

        <dxi-data-grid-column caption="Date"
                              dataField="careerValuation.creationDate"
                              dataType="date"
                              [format]="dateFormat"
                              [width]="100"></dxi-data-grid-column>

        <dxi-data-grid-column caption="Notes"
                              dataField="careerValuation.notes"
                              dataType="string"
                              [encodeHtml]="false"
                              cellTemplate="richTextTemplate"></dxi-data-grid-column>

        @for (careerValuationCategory of categories; track careerValuationCategory; let i = $index) {
            <dxi-data-grid-column caption="{{ careerValuationCategory.name }} notes"
                                  dataField="careerValuation.categoryValues[{{ i }}].notes"
                                  dataType="string"
                                  [encodeHtml]="false"
                                  cellTemplate="richTextTemplate"
                                  [visible]="false"></dxi-data-grid-column>
            <dxi-data-grid-column caption="{{ careerValuationCategory.name }} actual"
                                  dataField="careerValuation.categoryValues[{{ i }}].actualValue"
                                  dataType="number"
                                  [visible]="false"></dxi-data-grid-column>
            <dxi-data-grid-column caption="{{ careerValuationCategory.name }} ideal"
                                  dataField="careerValuation.categoryValues[{{ i }}].idealValue"
                                  dataType="number"
                                  [visible]="false"></dxi-data-grid-column>
        }

        <!-- END COLUMNS -->

        <div *dxTemplate="let item of 'personCellTemplate'">
            <adapt-link-person [person]="item.data.person"
                               nullValueText="(Anonymous person)"
                               [preventWrap]="true"></adapt-link-person>
        </div>

        <div *dxTemplate="let item of 'culturalLeaderCellTemplate'">
            <adapt-link-person [person]="item.data.culturalLeader"
                               [preventWrap]="true"
                               nullValueText="None allocated"></adapt-link-person>
        </div>

        <div *dxTemplate="let item of 'culturalLeaderGroupCellTemplate'">
            <div>
                @switch (!!item.value) {
                    @case (true) {
                        <div>
                            <span>{{ culturalLeadershipConfiguration.primaryName }}</span>:
                            <adapt-link-person [personId]="item.value"
                                               [preventWrap]="true"></adapt-link-person>
                        </div>
                    }
                    @case (false) {
                        <div>
                            No
                            <span>{{ culturalLeadershipConfiguration.primaryName }}</span>
                        </div>
                    }
                }
            </div>
        </div>

        <div *dxTemplate="let item of 'richTextTemplate'">
            <div [froalaView]="item.value"></div>
        </div>
    </dx-data-grid>
</div>
